import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UbiDonutChartModule } from 'uber-ui';

import { SharedModule } from 'modules/shared/shared.module';

import { DashboardRoutingModule } from './dashboard-routing.module';

import { TasksService } from './services/tasks.service';

import { DashboardPage } from './pages/dashboard/dashboard.page';

import { TasksCardComponent } from './components/tasks-card/tasks-card.component';
import { TaskTableComponent } from './components/tasks-card/task-table/task-table.component';

@NgModule({
  declarations: [
    DashboardPage,

    TasksCardComponent,
    TaskTableComponent
  ],
  imports: [
    CommonModule,

    UbiDonutChartModule,

    SharedModule,

    DashboardRoutingModule
  ],
  providers: [
    TasksService
  ]
})
export class DashboardModule { }
